import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://nghnmpgjwzyjdgcnfxsi.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5naG5tcGdqd3p5amRnY25meHNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ1ODE0NjgsImV4cCI6MjA5MDE1NzQ2OH0.3inUhn6Bg8lg3SOq9AGYfke3an0TOxkcEB46o3lNbIU'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

